/**
 * m/sufei-zepto 的值形如 "m/sufei-zepto"，在 gulp 打包时被替换
 */
pointman.require(["m/emit", "m/messenger", "m/sufei-zepto", "m/sufei-zepto_config"], function (emit, messenger, SubMod, m_config) {
	'use strict';
	//消息模块是否初始化
	var messengerHasInit = false;
	var doc = document;
	var win = window;
	var head = doc.head || doc.getElementsByTagName('head')[0] || doc.documentElement;
	var last_scroll_top = -1;

	var Sufei = function () {
		//可配置项
		this.config = {
			app: '',
			version: '',
			sufeiStyle: ''
		};
		//缓存
		this.cache = {
			//被拦截的请求队列
			queue: [],
			//dialog对象
			dialog: null
		};
	};

	Sufei.prototype = {
		init: function (config) {
			var self = this;

			self.config.app = config.app || '';
			self.config.version = config.version || '';
			self.config.sufeiStyle = config.style || '';

			//事件：显示验证对话框
			emit.on('event:showDialog@sufei', function (url) {
				url += (/\?/.test(url)) ? '&' : '?';
				if (/tpl_redirect_url=http(s)?:\/\/sec\.(([\w\d])*?\.)?taobao\.com\/query\.htm/.test(decodeURIComponent(url))) {
					url = url.replace('query.htm%3F', 'query.htm%3Fsufeiversion%3D' + self.config.version + '%26app%3D' + self.config.app + '%26');
				} else {
					url += 'sufeiversion=' + self.config.version + '&app=' + self.config.app;
				}

				if (!self.cache.dialog) {
					//TODO 解决css版本问题
					self.loadCss(self.config.sufeiStyle, function () {
						self.createDialog(url);
					});
				} else {
					self.changeDialogStates({state: 'visible', url: url});
				}
			});

			new SubMod().init();
		},

		//加载CSS
		loadCss: function (url, callback) {
			if (!url) {
				return callback && callback();
			}

			var node = doc.createElement('link');
			node.charset = 'utf-8';
			node.rel = 'stylesheet';
			node.href = url;

			// Android 自带浏览器下，css 的 onload 不会触发
			// @see http://stackoverflow.com/questions/13944802/why-is-the-link-elements-onload-attribute-unreliable-for-android-stock-browsers

			var ua = navigator.userAgent;
			var is_android = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
			var timeout = 3000;
			var is_callback_called;

			var current_style_sheets_count = doc.styleSheets.length;

			var _t_check_loop = setInterval(function () {
				if (doc.styleSheets.length != current_style_sheets_count) {
					doCallback();
				}
			}, 300);

			function doCallback() {
				if (is_callback_called) return;
				is_callback_called = true;
				clearInterval(_t_check_loop);
				callback && callback();
			}

			if ('onload' in node) {
				node.onload = doCallback;
				if (is_android) {
					setTimeout(doCallback, timeout);
				}
			} else {
				node.onreadystatechange = function () {
					if (/loaded|complete/.test(node.readyState)) {
						doCallback();
					}
				};
			}

			head.appendChild(node);
			if (doc.createStyleSheet) {
				// 兼容老版本 IE
				doc.createStyleSheet(url);
			}
		},

		//是否是ie6、7
		isOldBrower: function () {
			var b = doc.createElement('b');
			b.innerHTML = '<!--[if lte IE 7]><i></i><![endif]-->';
			return b.getElementsByTagName('i').length === 1;
		},

		is_iOS: function () {
			var userAgent = window.navigator.userAgent.toLowerCase();
			return (/iphone|ipad|ipod/).test(userAgent);
		},

		//创建dialog
		createDialog: function (url) {
			var self = this;
			var dialog = doc.createElement('div');
			var mask;
			var content;
			//var maskIframe;
			var closeElement;
			//iframe窗口
			var frameWin;

			mask = doc.createElement('div');
			content = doc.createElement('div');
			closeElement = doc.createElement('div');

			//可以通过sufeiStyle重定义dialog、mask风格
			if (self.config.app !== '') {
				dialog.className = 'sufei-dialog sufei-dialog-' + self.config.app;
			} else {
				dialog.className = 'sufei-dialog';
			}

			mask.className = 'sufei-dialog-mask';
			//IE6\7下为mask增加iframe
			if (self.isOldBrower()) {
				mask.innerHTML = '<iframe frameborder="none" src="javascript:\'\'"></iframe>';
			}

			//关闭按钮
			closeElement.className = 'sufei-dialog-close';
			closeElement.innerHTML = '关闭';

			content.className = 'sufei-dialog-content';
			content.innerHTML = '<iframe id="sufei-dialog-content" frameborder="none" src="' + url + '"></iframe>';

			content.appendChild(closeElement);
			dialog.appendChild(mask);
			dialog.appendChild(content);
			doc.body.appendChild(dialog);

			//function adjust() {
				//dialog.style.postion = "absolute";
				//var top = doc.documentElement.scrollTop || doc.body.scrollTop || 0;
				//dialog.style.top = top + "px";
				//dialog.style.height = doc.documentElement.clientHeight + "px";
			//}

			if (this.is_iOS()) {
				// 处理 iOS 下 fixed 定位在虚拟键盘弹出后的问题
				var fix_class = "sufei-ios-fix-fixed";
				var body_class = doc.body.className;
				if (body_class.indexOf(fix_class) == -1) {
					doc.body.className = (body_class + " " + fix_class).replace(/^\s+|\s+$/g, "");
				}

				// 禁止浏览器滚动
				// overflow-y: hidden对body不生效
				var body = doc.body;

				emit.on('event:dialogShow@sufei', function() {
					last_scroll_top = body.scrollTop;

					// 设置scrollTop=0, dialog为body的高度，防止bounce时看到上下的内容
					body.scrollTop = 0;
					dialog.style.height = body.scrollHeight + "px";

					// 防止滚动过快时继续往下走
					setTimeout(function () {
						body.scrollTop = 0;
					}, 200);
					// doc.addEventListener('touchmove', preventDefault, false);
				});
				emit.on('event:dialogHide@sufei', function() {
					body.scrollTop = last_scroll_top;
					// doc.removeEventListener('touchmove', preventDefault, true);
				});

				emit.fire('event:dialogShow@sufei');

				// absolute 定位
				// dialog.style.top = doc.body.scrollTop + "px";

				//adjust();
				//win.addEventListener("scroll", adjust);
				//win.addEventListener("resize", function () {
				//	adjust();
				//});

				// last_scroll_top = doc.body.scrollTop;
				// doc.body.scrollTop = 0;
				// setTimeout(function () {
				// 	doc.body.scrollTop = 0;
				// }, 100);
			}

			this.frame = doc.getElementById('sufei-dialog-content');
			frameWin = this.frame.contentWindow;
			messenger.initListener({
				currentWin: window,
				originWin: frameWin,
				msgTransfer: 'fromFrame'
			});
			//标记消息模块已初始化
			messengerHasInit = true;

			//消息: 验证通过
			messenger.register('msg:validateSuccess@sufei', function (data) {
				//重新发送请求
				emit.fire('event:resendRequest@sufei', data);
				//隐藏dialog
				self.changeDialogStates({state: 'hidden'});
				//消息: 重置验证码
				messenger.send({
					type: 'msg:resetCheckCode@sufei',
					content: ''
				});
			});

			//绑定关闭事件
			if (closeElement.addEventListener) {
				closeElement.addEventListener('click', function () {
					self.changeDialogStates({state: 'hidden'});
				}, false);
			} else {
				closeElement.attachEvent('onclick', function () {
					self.changeDialogStates({state: 'hidden'});
					return false;
				});
			}

			self.cache.dialog = dialog;
		},

		/*
		 * 改变dialog显示状态
		 * @param {string} obj.state hidden|visible
		 */
		changeDialogStates: function (obj) {
			if (obj.state === 'hidden') {
				//清空拦截队列
				emit.fire('event:cleanHijackQueue@sufei', {});
				//隐藏dialog
				this.cache.dialog.style.display = 'none';

				emit.fire('event:dialogHide@sufei');
				// if (last_scroll_top >= 0) {
				// 	doc.body.scrollTop = last_scroll_top;
				// }
			} else {
				// if (this.is_iOS()) {
					// last_scroll_top = doc.body.scrollTop;
					// doc.body.scrollTop = 0;
					// setTimeout(function () {
					// 	doc.body.scrollTop = 0;
					// }, 100);
				// }
				emit.fire('event:dialogShow@sufei');

				//显示dialog
				if (obj.url && this.frame.src != obj.url) {
					// 更新 iframe url
					this.frame.src = obj.url;
				}
				this.cache.dialog.style.display = 'block';

				//消息: 刷新验证码
				messengerHasInit && messenger.send({
					type: 'msg:refreshCheckCode@sufei',
					content: ''
				});
			}
		}
	};

	var sufeiMod = new Sufei();
	sufeiMod.init(m_config);
});
